<ng-container *mcRerender="numberOfRenderers">
  <form
    [id]="formName"
    [formGroup]="_visibleFormControls"
    [name]="formName"
    [ngClass]="className"
    (ngSubmit)="onFormSubmit()"
  >
    @for (formRow of _visibleRowDefinitions; track trackByFieldsRow(j); let j =
    $index) {
    <div
      [ngClass]="formRow.className || getFormRowClassName(formRow.items.length)"
    >
      @for (formField of formRow.items; track trackByField(i, formField); let i
      = $index) {
      <div [ngClass]="[formField.containerClassName]">
        <pax-form-field
          [field]="formField"
          [control]="getControlByFormField(formField)"
          [notifications$]="notificationObservable"
          [htmlIdPrefix]="htmlIdPrefix"
          (focusChange)="onFocusChange($event)"
        ></pax-form-field>
      </div>
      }
    </div>
    }
  </form>
</ng-container>
